export enum PatientTypes {
    Major = 1,
    Minor = 2,
}

export const AGE_THRESHOLD = 18;